import { useEffect } from "react";
import { CheckCircle2, X } from "lucide-react";

// Loud, unmistakable confirmation that a practice was logged. Fires once per
// click of "Mark Practice Complete" — replaces the old faint "Logged." line
// under the button which parents were missing. Auto-dismisses after 3.2s.
export default function PracticeCelebrateModal({ open, onClose, childName, tribe, practicesDone, target = 28, nextSession }) {
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(onClose, 3200);
    return () => clearTimeout(t);
  }, [open, onClose]);

  if (!open || !tribe) return null;
  const remaining = Math.max(0, target - practicesDone);
  const subline = remaining > 0
    ? `${remaining} more to unlock session ${nextSession}.`
    : `You've hit the ${target}-practice target for this session.`;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center px-4"
      data-testid="practice-celebrate-modal"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm animate-in fade-in duration-200" />
      <div
        className="relative max-w-sm w-full rounded-3xl shadow-2xl px-7 py-8 text-center animate-in fade-in zoom-in-95 duration-300"
        style={{ background: "#FFFEF9", border: `3px solid ${tribe.accent}` }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          data-testid="practice-celebrate-close"
          className="absolute top-3 right-3 w-8 h-8 rounded-full flex items-center justify-center hover:bg-black/5 transition-colors"
          aria-label="Dismiss"
        >
          <X size={16} className="opacity-60" />
        </button>
        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto animate-in zoom-in-50 duration-500"
          style={{ background: tribe.accent }}
        >
          <CheckCircle2 size={34} style={{ color: tribe.panel_ink || "#FFFEF9" }} />
        </div>
        <div className="mt-5 text-xs uppercase tracking-[0.35em] font-bold" style={{ color: tribe.accent }}>
          Practice logged
        </div>
        <h2 className="font-display text-2xl font-bold mt-2 text-navy leading-tight">
          Great work{childName ? `, ${childName}` : ""}!
        </h2>
        <p className="mt-2 text-ink-mid text-sm">
          You logged another practice. {subline}
        </p>
      </div>
    </div>
  );
}
